export default {
  title: "New Timeline Item",
  defaultName: "Item Name",
  name: "Item Name",
  customName: "Custom Timeline Item Name",
  addCustomName: "+ Custom Name",
  location: "Location",
  date: "Date of Timeline Item",
  time: "Time of Timeline Item",
  notes: "Notes",
  next: "NEXT",
  update: "UPDATE",
  back: "Cancel",
};



// WEBPACK FOOTER //
// ./src/components/forms/timeline-event-form/TimelineEventForm.messages.js